import React from 'react';
import { Button, Box, Typography, useTheme } from '@quillbot/design-system';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const salesSteps = [
  {
    image: 'rocket.png',
    header: '1. Sign Up',
    description: 'It takes less than a minute',
  },
  {
    image: 'computer.png',
    header: '2. Share',
    description: 'Share a URL with your network',
  },
  {
    image: 'moneyBag.png',
    header: '3. Earn',
    description: 'Earn big in multiple ways',
  },
];

interface IProps {
  classes: Record<string, string>;
}

function SalesStepsMobile(props: IProps) {
  const theme = useTheme();
  const publicFolderURL = `images/theme/${theme.palette.mode}/affiliatePage`;
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = salesSteps.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };

  return (
    <Box display="flex" flexDirection="row">
      <Box mt={10}>
        <Button size="large" onClick={handleBack} disabled={activeStep === 0}>
          <img src="/images/arrow.svg" style={{ transform: 'rotate(180deg)' }} alt="arrow" />
        </Button>
      </Box>

      <Box style={{ width: '60vw' }}>
        <AutoPlaySwipeableViews
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
          {salesSteps.map((ele) => (
            <Box
              mt={5}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              key={ele.description}
            >
              <img
                src={`${publicFolderURL}/${ele.image}`}
                height="116px"
                width="120px"
                style={{ margin: 'auto' }}
                alt={ele.description}
              />
              <Box mt={2}>
                <Typography
                  style={{ fontWeight: 'bold' }}
                  align="center"
                  variant="h6"
                  className={`${props.classes.font21} ${props.classes.titleContent} `}
                >
                  {ele.header}
                </Typography>
              </Box>
              <Typography
                paragraph
                align="center"
                variant="body1"
                className={props.classes.affiliateDescriptionNoPad}
              >
                {ele.description}
              </Typography>
            </Box>
          ))}
        </AutoPlaySwipeableViews>
      </Box>

      <Box mt={10}>
        <Button size="large" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
          <img src="/images/arrow.svg" alt="arrow" />
        </Button>
      </Box>
    </Box>
  );
}

export default SalesStepsMobile;
